<ng-template #visibilityTmpl>
  <rt-visibility-selector-dropdown
    [visibility]="visibilityControl().value"
    [labels]="visibilityLabels.dropdown"
    (changeVisibilityLevel)="onVisibilityChanges($event)"
  >
    <rt-icon-button
      header-prefix
      [iconName]="'arrow-back'"
      size="small"
      variant="plain"
      (click)="mainDropdown.prevTemplate()"
    />
  </rt-visibility-selector-dropdown>
</ng-template>

<rt-dropdown-item
  [class.item-disabled]="isViewPredefined()"
  [hasHoverEffect]="!isViewPredefined()"
  [rtTooltip]="'app.views.view_settings.visibility_public_disabled_tooltip' | translate"
  [rtTooltipEnabled]="isViewPredefined()"
  rtTooltipPosition="left"
  [targetFor]="isViewPredefined() ? undefined : visibilityTmpl"
  (click)="!isViewPredefined() && viewsAnalytics.settingsVisibilityOpen()"
>
  <rt-icon prefix name="lock" />
  <div layout-vertical>
    <div layout layout-space-between>
      <span>{{ 'app.views.view_page.visibility_options' | translate }}</span>
      <rt-icon name="chevron-right" />
    </div>
    <div layout text-small text-weight-default text-color class="description">
      {{ visibilityLabels.selected[visibilityControl().value.level] }}
      @if (visibilityControl().value.level === VisibilityLevel.Protected) {
        <span (click)="onVisibilityAvatarsClick($event)" layout margin-left-small-xx>
          <rt-admins-avatars
            [admins]="$any(visibilityUsersData?.rolesWithAdmins ?? [])"
            [isRole]="true"
            [stacked]="true"
            [limit]="visibilityAvatarMaxLength"
            [isShort]="true"
            [hasStopPropagation]="false"
            avatarSize="small-x"
            margin-right-small-x
          />
          <rt-admins-avatars
            [admins]="visibilityUsersData?.admins ?? []"
            [limit]="visibilityAvatarMaxLength"
            [isShort]="true"
            [stacked]="true"
            [hasStopPropagation]="false"
            avatarSize="small-x"
            margin-right-small-x
          />
        </span>
      }
    </div>
  </div>
</rt-dropdown-item>
